// AUTO-GENERATED by scripts/generate-blog-manifest.mjs
// Do not edit manually.
import Post0, {
  frontmatter as Post0Frontmatter,
} from "../../../content/drafts/agentic-design-systems/agentic-design-systems-need-operating-models-not-more-components.mdx";
import Post1, {
  frontmatter as Post1Frontmatter,
} from "../../../content/posts/branding-design-systems-essay.mdx";
import Post2, {
  frontmatter as Post2Frontmatter,
} from "../../../content/drafts/agentic-design-systems/component-contracts-are-where-taste-becomes-infrastructure.mdx";
import Post3, {
  frontmatter as Post3Frontmatter,
} from "../../../content/posts/design-system-meets-ai-building-the-self-evolving-component-library-pt-1.mdx";
import Post4, {
  frontmatter as Post4Frontmatter,
} from "../../../content/posts/design-system-meets-ai-building-the-self-evolving-component-library-pt-2.mdx";
import Post5, {
  frontmatter as Post5Frontmatter,
} from "../../../content/posts/designing-in-2025.mdx";
import Post6, {
  frontmatter as Post6Frontmatter,
} from "../../../content/posts/digital-craftsmanship.mdx";
import Post7, {
  frontmatter as Post7Frontmatter,
} from "../../../content/posts/figma-mcp-design-systems.mdx";
import Post8, {
  frontmatter as Post8Frontmatter,
} from "../../../content/drafts/agentic-design-systems/from-designops-to-agentops.mdx";
import Post9, {
  frontmatter as Post9Frontmatter,
} from "../../../content/posts/from-tokens-to-thinking-systems-making-ai-native-design-systems-actually-work.mdx";
import Post10, {
  frontmatter as Post10Frontmatter,
} from "../../../content/posts/in-search-of-impact.mdx";
import Post11, {
  frontmatter as Post11Frontmatter,
} from "../../../content/posts/petri-lahdelma-bio.mdx";
import Post12, {
  frontmatter as Post12Frontmatter,
} from "../../../content/posts/plausible-accessibility.mdx";
import Post13, {
  frontmatter as Post13Frontmatter,
} from "../../../content/posts/the-evolutionary-difference-between-constructive-and-constrictive-criticism.mdx";
import Post14, {
  frontmatter as Post14Frontmatter,
} from "../../../content/drafts/agentic-design-systems/the-minimum-viable-agent-ready-design-system.mdx";
import Post15, {
  frontmatter as Post15Frontmatter,
} from "../../../content/posts/thoughts-on-future-branding.mdx";
import Post16, {
  frontmatter as Post16Frontmatter,
} from "../../../content/drafts/agentic-design-systems/tools-harnesses-and-skills-the-missing-model-for-design-systems.mdx";
import Post17, {
  frontmatter as Post17Frontmatter,
} from "../../../content/posts/workflow-tips.mdx";

export type BlogManifestEntry = {
  slug: string;
  Component: import("react").ComponentType;
  frontmatter?: {
    title?: string;
    excerpt?: string;
    readTime?: string;
    publishedAt?: string;
    intendedPublishedAt?: string;
    draft?: boolean;
    status?: string;
    seoTitle?: string;
    seoDescription?: string;
    legacyUrl?: string;
    authorName?: string;
    authorSlug?: string;
    mainImageUrl?: string;
    mainImageAlt?: string;
    mainImageCaption?: string;
    tags?: string[];
    modifiedAt?: string;
  };
};

export const blogManifest: BlogManifestEntry[] = [
  {
    slug: "agentic-design-systems-need-operating-models-not-more-components",
    Component: Post0 as unknown as import("react").ComponentType,
    frontmatter: Post0Frontmatter,
  },
  {
    slug: "branding-design-systems-essay",
    Component: Post1 as unknown as import("react").ComponentType,
    frontmatter: Post1Frontmatter,
  },
  {
    slug: "component-contracts-are-where-taste-becomes-infrastructure",
    Component: Post2 as unknown as import("react").ComponentType,
    frontmatter: Post2Frontmatter,
  },
  {
    slug: "design-system-meets-ai-building-the-self-evolving-component-library-pt-1",
    Component: Post3 as unknown as import("react").ComponentType,
    frontmatter: Post3Frontmatter,
  },
  {
    slug: "design-system-meets-ai-building-the-self-evolving-component-library-pt-2",
    Component: Post4 as unknown as import("react").ComponentType,
    frontmatter: Post4Frontmatter,
  },
  {
    slug: "designing-in-2025",
    Component: Post5 as unknown as import("react").ComponentType,
    frontmatter: Post5Frontmatter,
  },
  {
    slug: "digital-craftsmanship",
    Component: Post6 as unknown as import("react").ComponentType,
    frontmatter: Post6Frontmatter,
  },
  {
    slug: "figma-mcp-design-systems",
    Component: Post7 as unknown as import("react").ComponentType,
    frontmatter: Post7Frontmatter,
  },
  {
    slug: "from-designops-to-agentops",
    Component: Post8 as unknown as import("react").ComponentType,
    frontmatter: Post8Frontmatter,
  },
  {
    slug: "from-tokens-to-thinking-systems-making-ai-native-design-systems-actually-work",
    Component: Post9 as unknown as import("react").ComponentType,
    frontmatter: Post9Frontmatter,
  },
  {
    slug: "in-search-of-impact",
    Component: Post10 as unknown as import("react").ComponentType,
    frontmatter: Post10Frontmatter,
  },
  {
    slug: "petri-lahdelma-bio",
    Component: Post11 as unknown as import("react").ComponentType,
    frontmatter: Post11Frontmatter,
  },
  {
    slug: "plausible-accessibility",
    Component: Post12 as unknown as import("react").ComponentType,
    frontmatter: Post12Frontmatter,
  },
  {
    slug: "the-evolutionary-difference-between-constructive-and-constrictive-criticism",
    Component: Post13 as unknown as import("react").ComponentType,
    frontmatter: Post13Frontmatter,
  },
  {
    slug: "the-minimum-viable-agent-ready-design-system",
    Component: Post14 as unknown as import("react").ComponentType,
    frontmatter: Post14Frontmatter,
  },
  {
    slug: "thoughts-on-future-branding",
    Component: Post15 as unknown as import("react").ComponentType,
    frontmatter: Post15Frontmatter,
  },
  {
    slug: "tools-harnesses-and-skills-the-missing-model-for-design-systems",
    Component: Post16 as unknown as import("react").ComponentType,
    frontmatter: Post16Frontmatter,
  },
  {
    slug: "workflow-tips",
    Component: Post17 as unknown as import("react").ComponentType,
    frontmatter: Post17Frontmatter,
  },
];
